
export const CASE_NOTE_TYPE_GENERAL = "general";
export const CASE_NOTE_TYPE_APPRAISER = "appraiser";